// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__8rB-b","largestCol":"styles_largestCol__2OvHt","smallestCol":"styles_smallestCol__3haXS"};